import {AfterViewInit, Component, OnInit} from '@angular/core';
import {CmsService} from '../cms.service';
import {Constants} from '../../../shared/utils/constants';
import {AppService} from '../../../app.service';

declare var $: any;

@Component({
  selector: 'fx-bonus-code',
  templateUrl: './bonus-code.component.html',
  styleUrls: ['./bonus-code.component.sass']
})
export class BonusCodeComponent implements OnInit, AfterViewInit {
  pageInfo: any = {
    pageSize: 10,
    pageIndex: 1,
    totalRecord: 0
  };
  userId = null;
  datas = [];
  constructor(
    private service: CmsService,
    private appService: AppService) { }

  ngOnInit(): void {
  }
  showModalCode(userId): void {
    this.userId = userId;
    this.getBonusEvents();
    $('#bonusCodeInformation').trigger('click');
  }

  getBonusEvents(): void {
    this.datas = [];
    const param = {
      user_id: this.userId,
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize
    }
    this.service.getBonusEventHistory(param).subscribe(res => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.datas = res.data;
        this.pageInfo.totalRecord = res.paging.total;
      }
    });
  }
  onUpdateMode(item): void {
    const body = {
      bonus_event_id: item.bonus_event_id,
      user_id: this.userId,
      mode: item.mode
    };
    this.service.updateBonusEvent(body).subscribe(res => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.appService.showSuccess('Update mode success');
      }
    });
  }
  getLabel(key): string {
    switch (key) {
      case 0: {
        return 'Disabled';
      }
      case 1: {
        return 'Ongoing';
      }
      case 2: {
        return 'Expired';
      }
    }
  }

  pageChanged(page: number): void {
    this.pageInfo.pageIndex = page;
    this.getBonusEvents();
  }

  ngAfterViewInit(): void {
    $('#modalBonusCodeInformation').on('hide.bs.modal', () => {
      this.datas = [];
    });
  }

}
